var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#12575F"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#12575F",
    strokeWidth: 0.5,
    d: "M11.95 4.75a6.09 6.09 0 00-5.94 6.45c.17 3.06 4.14 7.08 5.5 8.36a.65.65 0 00.9 0c1.35-1.27 5.32-5.25 5.48-8.36a6.09 6.09 0 00-5.94-6.45m0 .75a5.36 5.36 0 015.2 5.66c-.13 2.25-2.75 5.49-5.2 7.8-2.44-2.34-5.07-5.6-5.2-7.8a5.34 5.34 0 015.2-5.66"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.25,
    d: "M11.95 12.94a2.2 2.2 0 110-4.4 2.2 2.2 0 010 4.4z"
  }))));
}

export default SvgIconPin;